import { store } from '@/store';
import api from '@api/Api';

export default {

    getAgency(id) {
        return api().get(`/agencies/${id}`);
    },

    getAgencyByDomain(params) {
        return api().get(`/agencies`, { params: params });
    },

    updateAgency(id, params) {
        return api().put(`/agencies/${id}`, params).then((response) => {
            store.commit('setAgency', response.data.data);
            return response;
        });
    },

    updateAgencyBranding(id, params) {
        return api().put(`/agencies/${id}/branding`, params).then((response) => {
            store.commit('setAgency', response.data.data);
            return response;
        });
    },

    updateAgencyEmail(id, params) {
        return api().put(`/agencies/${id}/email`, params);
    },

    updateAgencyEmailAppearance(id, params) {
        return api().put(`/agencies/${id}/email/appearance`, params);
    },

    updateAgencyAmbassador(id, params) {
        return api().put(`/agencies/${id}/ambassador`, params);
    },

    updateAgencyMeta(id, params) {
        return api().put(`/agencies/${id}/meta`, params);
    },

    updateAgencyRobots(id, params) {
        return api().put(`/agencies/${id}/robots`, params);
    },

    getAgencySso(id) {
        return api().get(`/agencies/${id}/sso`);
    },

    updateAgencySso(id, params) {
        return api().put(`/agencies/${id}/sso`, params);
    },

    updateAgencyCode(id, params) {
        return api().put(`/agencies/${id}/code`, params);
    },

    createAgencyCname(id, params) {
        return api().post(`/agencies/${id}/cname`, params);
    },

    updateAgencyCname(id, params) {
        return api().put(`/agencies/${id}/cname`, params);
    },

    deleteAgencyCname(id, params) {
        return api().delete(`/agencies/${id}/cname`, { data: params });
    },

    deleteAgency(id) {
        return api().delete(`/agencies/${id}`).then((response) => {
            store.commit('setUser', response.data.data);
            return response;
        });
    },

    /***
     * Key
     */

    getKey(id) {
        return api().get(`/agencies/${id}/key`);
    },

    deleteKey(id) {
        return api().delete(`/agencies/${id}/key`);
    },

    /**
     * OAuth Clients
     */

    deleteOAuthClient(id, client_id) {
        return api().delete(`/agencies/${id}/oauth/clients/${client_id}`);
    },

    getOAuthClients(id) {
        return api().get(`/agencies/${id}/oauth/clients`);
    },

    /**
     * Templates
     */

    getTemplates(id) {
        return api().get(`/agencies/${id}/templates`);
    },

    /**
     * Links
     */

    getLinks(id) {
        return api().get(`/agencies/${id}/links`);
    },

    createLink(id, params) {
        return api().post(`/agencies/${id}/links`, params);
    },

    sortLinks(id, params) {
        return api().put(`/agencies/${id}/links`, params);
    },

    updateLink(link, params) {
        return api().put(`/agencies/${link.agency_id}/links/${link.id}`, params);
    },

    deleteLink(link) {
        return api().delete(`/agencies/${link.agency_id}/links/${link.id}`);
    },

    /**
     * DNS Records
     */

    downloadDnsRecords(id) {
        return api().get(`/agencies/${id}/dns-records/download`);
    },

}